import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`CombustaoMovel/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td>{rs.combustivelUtilizado}</td>
                    <td>{rs.quantidadeConsumida}</td>
                    <td>{rs.unidades}</td>
                    <td>{rs.emissoesCO2}</td>
                    <td>{rs.emissoesCH4}</td>
                    <td>{rs.emissoesNO2}</td>
                    <td>{rs.emissoesCO2Bio}</td>
                    <td>{rs.emissoesCH4Bio}</td>
                    <td>{rs.emissoesNO2Bio}</td>
                    <td>{rs.emissoesFosseisTotais}</td>
                    <td>{rs.emissoesBioTotais}</td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th tyle={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Descr. Frota
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                TIpo Frota
                                </center>

                            </th>
                        
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Ano Frota
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Cons. anual
                                </center>

                            </th>


                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. CO<sup>2</sup> Fosseis
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. CH<sup>4</sup>
                                </center>

                            </th>
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. NO<sup>2</sup>
                                </center>

                            </th>
                           

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. Totais
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. CO<sup>2</sup> Bio
                                </center>

                            </th>

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel